import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const breadcrumbsSeparatorFn = /* @__PURE__ */ createRecipe('breadcrumbs-separator', {}, [])

const breadcrumbsSeparatorVariantMap = {}

const breadcrumbsSeparatorVariantKeys = Object.keys(breadcrumbsSeparatorVariantMap)

export const breadcrumbsSeparator = /* @__PURE__ */ Object.assign(memo(breadcrumbsSeparatorFn.recipeFn), {
  __recipe__: true,
  __name__: 'breadcrumbsSeparator',
  __getCompoundVariantCss__: breadcrumbsSeparatorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: breadcrumbsSeparatorVariantKeys,
  variantMap: breadcrumbsSeparatorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, breadcrumbsSeparatorVariantKeys)
  },
  getVariantProps: breadcrumbsSeparatorFn.getVariantProps,
})